import "./App.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core"
import { StylesProvider } from "@material-ui/styles";
import Routes from "./routes/Routes";
import AxiosInterceptor from "./libs/services/interceptor";
import { CircularProgress } from "@material-ui/core";
import theme from "./theme";
import Helmet from 'react-helmet';
import UtilsService from "./libs/services/utils";


function ProcessingLoader({ }) {
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const setProcessingSubscription = UtilsService.processing.subscribe((value) => {
      setProcessing(value);
    })

    return () => {
      setProcessingSubscription.unsubscribe();
    }
  }, [])

  return <div className="circle-loader" style={{ visibility: processing ? "visible" : "hidden" }}>
    <CircularProgress color="primary" />
  </div>
}

function App() {
  const [interceptor, setInterceptor] = useState(0);

  useEffect(() => {
    let i = AxiosInterceptor();
    if (i) { setInterceptor(1) }

    return () => {
    }
  }, [])

  return (
    interceptor ?
      <React.Fragment>
        <Helmet
          titleTemplate="%s | Reinsurance Portal"
          defaultTitle="Reinsurance Portal"
        />
        <StylesProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <div className="App">
              {/* <HistoryRouter history={history}> */}
              <Routes />
              {/* </HistoryRouter> */}
            </div>
          </MuiThemeProvider>
        </StylesProvider>
        <ProcessingLoader/>
      </React.Fragment> : <React.Fragment></React.Fragment>
  );
}

export default connect(store => ({ theme: store.themeReducer }))(App);
